import byIdMaker from 'reducersMakers/byIdMaker';
import * as actions from 'actions';

export default byIdMaker({
  fetchSuccessTypes: [
    actions.FORUM_THREADS_FETCH_SUCCESS,
    actions.FORUM_THREAD_PROFILE_FETCH_SUCCESS,
    actions.FORUM_SIDEBAR_THREADS_FETCH_SUCCESS,
    actions.FORUM_THREADS_RECEIVED
  ],
  updateSuccessTypes: [actions.FORUM_THREAD_UPDATE],
  updateKey: 'forumThreadId',
  entityType: 'forumThreads'
});



/** WEBPACK FOOTER **
 ** ./src/members/state/forum/forumThreads/byId/reducer.js
 **/